import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
const services = [{
  title: 'Residential Pickup'
}, {
  title: 'Budget Bag Service'
}, {
  title: 'Commercial Dumpsters'
}, {
  title: 'Construction & Clean-Out Hauling'
}, {
  title: 'Bulk Item Pickup'
}, {
  title: 'Temporary Dumpsters'
}];
export function Header() {
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const [isMobileServicesOpen, setIsMobileServicesOpen] = useState(false);
  return <header className="bg-white shadow-sm" data-id="element-68">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-69">
        <div className="flex justify-between items-center py-4" data-id="element-70">
          {/* Logo and Tagline */}
          <div className="flex items-center gap-3" data-id="element-71">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rYyHQnqA6sgXSrChTLK2Yb/Sams-Disposal-logo.png" alt="Sam's Disposal" className="h-16 w-auto" data-id="element-72" />
            <div className="hidden md:block border-l-2 border-gray-300 pl-3" data-id="element-73">
              <p className="text-sm font-bold text-gray-700 leading-tight" data-id="element-74">
                Local. Reliable.
                <br data-id="element-75" />
                Family Owned.
              </p>
            </div>
          </div>
          {/* Navigation */}
          <nav className="hidden lg:flex items-center gap-10" data-id="element-76">
            <a href="#home" className="text-gray-900 font-bold hover:text-[#E41C1C] transition-colors" data-id="element-77">
              Home
            </a>
            {/* Services Dropdown */}
            <div className="relative" onMouseEnter={() => setIsServicesOpen(true)} onMouseLeave={() => setIsServicesOpen(false)} data-id="element-78">
              <button className="flex items-center gap-1 text-gray-900 font-bold hover:text-[#E41C1C] transition-colors" data-id="element-79">
                Services
                <ChevronDownIcon className="w-4 h-4" data-id="element-80" />
              </button>
              {/* Dropdown Menu */}
              {isServicesOpen && <div className="absolute top-full left-0 mt-2 w-64 bg-white shadow-xl rounded-lg border border-gray-200 py-2 z-50" data-id="element-81">
                  {services.map((service, index) => <a key={index} href="#services" className="block px-4 py-3 text-gray-900 font-bold text-sm hover:bg-gray-50 transition-colors" data-id="element-82">
                      {service.title}
                    </a>)}
                </div>}
            </div>
            <a href="#about" className="text-gray-900 font-bold hover:text-[#E41C1C] transition-colors" data-id="element-83">
              About
            </a>
            <a href="#contact" className="text-gray-900 font-bold hover:text-[#E41C1C] transition-colors" data-id="element-84">
              Contact
            </a>
          </nav>
          {/* CTAs and Phone */}
          <div className="flex items-center gap-6" data-id="element-85">
            <div className="hidden lg:flex items-center gap-4" data-id="element-86">
              <a href="https://www.trashbilling.com/" target="_blank" rel="noopener noreferrer" className="bg-[#E41C1C] text-white font-bold px-4 py-2 rounded hover:bg-red-700 transition-colors text-sm" data-id="element-87">
                Pay Bill
              </a>
              <a href="#reed-city-registration" className="bg-[#002868] text-white font-bold px-4 py-2 rounded hover:bg-[#001f4d] transition-colors text-sm" data-id="element-88">
                Reed City Customer Registration
              </a>
            </div>
            <a href="tel:231-796-2952" className="text-[#E41C1C] font-bold text-lg hover:text-red-700 transition-colors" data-id="element-89">
              231-796-2952
            </a>
          </div>
        </div>
        {/* Mobile Navigation */}
        <nav className="lg:hidden flex flex-col pb-4 border-t pt-4" data-id="element-90">
          <div className="flex justify-center gap-6 mb-2" data-id="element-91">
            <a href="#home" className="text-gray-900 font-bold text-sm hover:text-[#E41C1C]" data-id="element-92">
              Home
            </a>
            {/* Mobile Services Dropdown */}
            <button onClick={() => setIsMobileServicesOpen(!isMobileServicesOpen)} className="flex items-center gap-1 text-gray-900 font-bold text-sm hover:text-[#E41C1C]" data-id="element-93">
              Services
              <ChevronDownIcon className="w-3 h-3" data-id="element-94" />
            </button>
            <a href="#about" className="text-gray-900 font-bold text-sm hover:text-[#E41C1C]" data-id="element-95">
              About
            </a>
            <a href="#contact" className="text-gray-900 font-bold text-sm hover:text-[#E41C1C]" data-id="element-96">
              Contact
            </a>
          </div>
          {/* Mobile Services Dropdown Content */}
          {isMobileServicesOpen && <div className="mt-2 bg-gray-50 rounded-lg p-2" data-id="element-97">
              {services.map((service, index) => <a key={index} href="#services" className="block px-3 py-2 text-gray-900 font-bold text-xs hover:bg-white rounded transition-colors" data-id="element-98">
                  {service.title}
                </a>)}
            </div>}
          {/* Mobile CTAs */}
          <div className="flex flex-col gap-2 mt-4" data-id="element-99">
            <a href="https://www.trashbilling.com/" target="_blank" rel="noopener noreferrer" className="bg-[#E41C1C] text-white font-bold px-4 py-2 rounded hover:bg-red-700 transition-colors text-sm text-center" data-id="element-100">
              Pay Bill
            </a>
            <a href="#reed-city-registration" className="bg-[#002868] text-white font-bold px-4 py-2 rounded hover:bg-[#001f4d] transition-colors text-sm text-center" data-id="element-101">
              Reed City Customer Registration
            </a>
          </div>
        </nav>
      </div>
    </header>;
}